export default "__VITE_ASSET__ea91c9d3__"